import { call, put, takeLatest } from 'redux-saga/effects';
import { YieldOf } from 'types/utils';
import { exportedUsers, exportUsers, fetchedUsers, fetchUsers } from './actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';
import { ServiceTypesGroupingModeValues, UserFilterParams } from 'types';

type FetchActionPayload = ReturnType<typeof fetchUsers>;
type ExportUsersPayload = ReturnType<typeof exportUsers>;

export function* getUsersSaga({ payload }: FetchActionPayload) {
  const { getUsersList } = getAPI();

  let params: UserFilterParams | undefined;
  if (payload) {
    const { trainTypeIDs, serviceTypesGroupingMode, ...rest } = payload;
    params = rest;
    if (trainTypeIDs?.length) {
      params.isExactFilterServiceType = serviceTypesGroupingMode === ServiceTypesGroupingModeValues.ET;
      params.trainTypeIDs = trainTypeIDs;
    }
  }

  const response: YieldOf<typeof getUsersList> = yield call(getUsersList, params);
  const { data, ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedUsers(data));
  } else {
    const error = problem || 'unknown';
    yield put(fetchedUsers(undefined, error));
  }
}

function* exportUsersSaga({ payload }: ExportUsersPayload) {
  const { exportUserList } = getAPI();

  let params: UserFilterParams | undefined;
  if (payload) {
    const { trainTypeIDs, serviceTypesGroupingMode, ...rest } = payload;
    params = rest;
    if (trainTypeIDs?.length) {
      params.isExactFilterServiceType = serviceTypesGroupingMode === ServiceTypesGroupingModeValues.ET;
      params.trainTypeIDs = trainTypeIDs;
    }
  }

  const response: YieldOf<typeof exportUserList> = yield call(exportUserList, params);
  const { data, ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(exportedUsers(data));
  } else {
    const error = problem || 'unknown';
    yield put(exportedUsers(undefined, error));
  }
}

export default function* usersSaga() {
  yield takeLatest(fetchUsers.type, getUsersSaga);
  yield takeLatest(exportUsers.type, exportUsersSaga);
}
